import { useState } from "react";
import { Modal } from "react-bootstrap";

type Props = {
  isSaving: boolean;
  onClose: () => void;
  onSubmit: (name: string) => void;
};

/*
    An objective starts as a name — the rest of its detail (population, list
    sizing, key dates) is filled in on the objective's own screens. Creating one
    here exists so a campaign always has something to belong to.
*/
export default function ObjectiveFormModal({ isSaving, onClose, onSubmit }: Props) {
  const [name, setName] = useState("");

  const canSubmit = name.trim().length > 0 && !isSaving;

  return (
    <Modal show onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "1rem" }}>New objective</Modal.Title>
      </Modal.Header>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (canSubmit) onSubmit(name.trim());
        }}
      >
        <Modal.Body>
          <label htmlFor="objectiveName" className="form-label small fw-semibold">
            Objective name
          </label>
          <input
            id="objectiveName"
            className="form-control"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. Fall 2026 Enrollment Growth"
            autoFocus
          />
          <div className="small text-muted mt-2">
            Campaigns are grouped under their objective. You can create campaigns in it as soon as
            it exists.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-sm btn-outline-secondary" onClick={onClose}>
            Cancel
          </button>
          <button type="submit" className="btn btn-sm btn-primary" disabled={!canSubmit}>
            {isSaving ? "Creating..." : "Create objective"}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
